import { createFileRoute, useNavigate } from '@tanstack/react-router'
import React from 'react'
import BuyCreditsModal from '../../../components/modals/BuyCreditsModal'
import { useAuth } from '../../../contexts/AuthContext'
import { useClientProfile } from '../../../hooks/useClientProfile'
import { AppLayout } from '../../../components/layouts/AppLayout'

export const Route = createFileRoute('/billing/credits')({
  component: BuyCreditsPage,
})

function BuyCreditsPage() {
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const clientQuery = useClientProfile(currentUser?.email)

  const handleClose = () => {
    navigate({ to: '/campaigns' })
  }

  return (
    <AppLayout
      currentView="campaigns"
      aiCredits={clientQuery.data?.credits ?? 0}
      creditsLoading={clientQuery.isPending}
      clientInfo={clientQuery.data}
    >
      <BuyCreditsModal isOpen={true} onClose={handleClose} />
    </AppLayout>
  )
}
